<template>
  <!-- 日本入荷一覧 -->
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 入荷 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.JP_RECEIVE.RECEIVE_BTN") }}
            </t-button></t-col
          ><t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button></t-col
          >
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="12">
                  <div>
                    <!-- 入荷日 -->
                    <t-form-item
                      :label="$t('resource.JP_RECEIVE.RECEIVE_DATE')"
                    >
                      <t-date-picker
                        v-model="jpReceDateRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        :editable="false"
                        style="min-width: 20px; width: 75%; margin-top: 8px"
                        class="date_icon_center"
                        :clearable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 状態 -->
                  <t-form-item :label="$t('resource.JP_RECEIVE.STATUS')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                      clearable
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="3">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxlength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="4" class="center">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="jpRcvTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
          fit
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 状態 -->
          <t-table-column
            prop="jrbReceStatus"
            :label="$t('resource.JP_RECEIVE.STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.JP_RECEIVE.STATUS'),
                'jrbReceStatus'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.jrbReceStatus }} </span>
              </div>
            </template>
          </t-table-column>
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="transportTableDataLength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import {
  ShowJpReceDLEditDialog,
  ShowJpReceJPOfficeEditDialog,
  ShowJpReceSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  deleteJpReceBasicByNo,
  initJpReceSearchList,
  searchJpReceBasic,
} from "@/services/jpReceive";
import {
  formatCurDateToString,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import {
  CONNECTOR_SHORT_LINE,
  GetPageDataCount,
  STR_EMPTY,
  STR_ONE,
  STR_ZERO,
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      // 検索条件
      jpReceDateRange: [],
      searchConditionForm: {
        searchStartDate: "", // 検索条件:入荷(開始日)
        searchEndDate: "", // 検索条件:入荷(終了日)
        searchStatus: "", // 検索条件:状態
        searchWord: "", // 検索キー
      },
      //ターブルデータ
      jpRcvTableData: [],

      // 日本入荷状態リスト(1：新規　2：検收中　3：検収済み　デフォルト値：1)
      statusList: [],

      // ターブル列
      columns: [
        // 工場
        {
          prop: "jrbFactoryKbnShow",
          label: t("resource.JP_RECEIVE.FACTORY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 入荷日
        {
          prop: "jrbReceDateOnly",
          label: t("resource.JP_RECEIVE.RECEIVE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 入荷No.
        {
          prop: "jrbReceNo",
          label: t("resource.JP_RECEIVE.JP_RCV_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
        },
        // 運送No
        {
          prop: "jrbTransOrderNo",
          label: t("resource.JP_RECEIVE.TRANSPORT_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 仕入先
        {
          prop: "jrbSupCode",
          label: t("resource.JP_RECEIVE.SUPPLIER_COMPANY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 担当者
        {
          prop: "jrbUserCode",
          label: t("resource.JP_RECEIVE.CONNECTER_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 支払状態
        {
          prop: "jrbPayStatus",
          label: t("resource.JP_RECEIVE.PAY_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 備考
        {
          prop: "jrbRemarks",
          label: t("resource.JP_RECEIVE.REMARKS"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],
      showFlag: false,
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      transportTableDataLength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    };
  },

  mounted() {
    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  computed: {
    tableData() {
      return this.jpRcvTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 画面初期化
    init() {
      this.showFlag = true;
      //検索条件リストの初期化
      initJpReceSearchList()
        .then((res) => {
          //日本入荷状態
          this.statusList = res.jpRcvStatusList;
          //日付初期化
          this.dateInit();
          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.jpReceDateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    // 「検索」ボタン
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      // 検索条件の処理;
      this.updateSearchForm();
      //検索運送基本情報
      searchJpReceBasic(this.searchConditionForm)
        .then((res) => {
          this.jpRcvTableData = res;
          // データ個数
          this.transportTableDataLength = this.jpRcvTableData.length;
          this.dataProcess();
          //列幅の設定
          setColumnWidth(this.columns, this.jpRcvTableData);
          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    dataProcess() {
      this.jpRcvTableData.map((item) => {
        if (item.jrbFactoryKbn === STR_ONE) {
          item.jrbSupCode = CONNECTOR_SHORT_LINE;
        }
      });
    },

    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      if (this.jpReceDateRange) {
        //入荷日:日付の設定
        this.searchConditionForm.searchStartDate = formatCurDateToString(
          this.jpReceDateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatCurDateToString(
          this.jpReceDateRange[1]
        );
      } else {
        //入荷日:日付の設定
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }
    },

    //複数行データの削除
    deleteClickSelected() {
      // フォーカス削除
      this.$refs.delBtn.$el.blur();

      let data = this.$refs.jpRcvTableData.selection;

      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        for (let index = 0; index < data.length; index++) {
          let dataStatus = data[index].jrbReceStatus;

          // // 「検收中、検収済み」のデータの削除が不可
          // if (STATUS_NEW != dataStatus) {
          //   deleteFlg = false;
          //   Message.showError(t("message.JP_RECEIVE.NOT_DELETE"), null);
          //   break;
          // }

          let jrbDelFlg = data[index].jrbDelFlg;
          if (jrbDelFlg != STR_ZERO) {
            Modal.showError("", t("message.JP_RECEIVE.NOT_DELETE_CUS_PAY"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            deleteFlg = false;
            break;
          }

          delList.push(data[index].jrbReceNo);
        }

        if (deleteFlg) {
          Modal.showWarning("", t("resource.sys.deleteMessage"), {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }).then(() => {
            if (!this.showFlag) {
              this.showFlag = true;
            }
            deleteJpReceBasicByNo(delList)
              .then(() => {
                //削除成功
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 「新規」ボタン
    addClick() {
      // フォーカス削除
      this.$refs.addBtn.$el.blur();

      // 入荷種類選択画面を表示;
      ShowJpReceSelectDialog(
        {
          isAdd: true,
        },
        t("resource.JP_RECEIVE.JP_RECE_SELECT_DIALOG"),
        this.searchClick
      );
    },

    //詳細
    detailClick(row) {
      if (row.jrbFactoryKbn == STR_ONE) {
        //日本入荷詳細画面（大連工場）
        ShowJpReceDLEditDialog(
          {
            isAdd: false,
            basicData: row,
          },
          t("resource.JP_RECEIVE.JP_RCV_DL_DETAIL_DIALOG"),
          this.searchClick
        );
      } else {
        // 日本入荷詳細画面（大連以外の工場）を表示
        ShowJpReceJPOfficeEditDialog(
          {
            isAdd: false,
            basicData: row,
          },
          t("resource.JP_RECEIVE.JP_RCV_OTHER_DETAIL_DIALOG"),
          this.searchClick
        );
      }
    },

    // ページング処理
    pageChange(val) {
      this.pageNo = val;
    },
    //毎ページ件数の設定
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    // ページあたりのデータ数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jpRcvTableData);
    },

    //状態の色の設定
    formatStatusColor(row) {
      if (!!row.statusColor) {
        return row.statusColor;
      }
    },

    //テーブルのソート
    tableSort(column) {
      //ソート後、最初のページに戻る
      this.pageNo = 1;
      masterService.tableSort(this.jpRcvTableData, column);
    },
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1;
}
</style>
